import type { FaireProductEntity } from "../../entity_types/product";

export const p_mm3yqfw93x: FaireProductEntity = {
  token: "p_mm3yqfw93x",
  type: "product",
  name: "Marinara Pasta Sauce with Oregano Flowers",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/6ebb14c834c5d728aba867d3f4fc3d5d343f0ae827451613c51879eeb24fa91c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27a5faebfb2e075e8a12a3406116c57a2b7c1149fabcc5646d55f094226e48c2.jpeg",
    "https://cdn.faire.com/fastly/a60bdf17687cceb0091d361b34f5f3acfa50ab66142ec2c0119f06f07b5ba9d4.jpeg",
    "https://cdn.faire.com/fastly/ff6fd0cdad6ca9b55dc63a8c10134877ffe626127af3f2cf2a499b16fa218869.jpeg",
    "https://cdn.faire.com/fastly/180be57cef3eecd5f46aac69a4a40969ca3a3d6e530f9fb337f4ea2558456f92.jpeg",
    "https://cdn.faire.com/fastly/8faeb031ab2d99f449a1c6f93aeeb3098e5ab0378ba030c721e92e319bb98a59.jpeg"
  ],
  priceDollars: 6.48,
  description: "As featured in The New York Times, our organic marinara sauce with oregano is pressed from our ancient Corleonese heirloom tomato varieties and seductively fragrant oregano flowers.\n",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:20.924Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
